<form [formGroup]="form">
  <div class="row">
    <label class="col-5 d-flex align-items-center control-label">
      <span class="label text-truncate">{{label}}</span><span [ngClass]="{'required': isRequired}"></span>
    </label>
    <div class="col-7">
      <ng-container [ngSwitch]="inputType">
        <input *ngSwitchCase="InputType.Input"
               class="form-control"
               formControlName="value">
        <input *ngSwitchCase="InputType.Float"
               type="number"
               class="form-control"
               formControlName="value">
        <app-yes-no-group-button *ngSwitchCase="InputType.Bool"
                                 [formControl]="formControlValue"></app-yes-no-group-button>
        <input *ngSwitchCase="InputType.Integer"
               class="form-control"
               type="number"
               formControlName="value">
        <ejs-dropdownlist *ngSwitchCase="InputType.Select"
                          [dataSource]="dropdownValues"
                          [fields]="dropdownSettings"
                          [showClearButton]="true"
                          formControlName="value"></ejs-dropdownlist>
      </ng-container>
      <app-error-messages [control]="form.controls.value" [showUntouchedErrors]="showUntouchedErrors"></app-error-messages>
    </div>

  </div>

</form>


